import { api } from '../../shared/api/http'

export type AiIncidentState = 'active' | 'recovered'
export type AiIncidentSeverity = 'warning' | 'error'
export type AiRuntimePhase = 'waiting_authorization' | 'preparing' | 'running' | 'authorization_expired' | 'suspended' | 'degraded' | 'stale'
export interface AiRuntimeHealth {
  inferenceAlive: boolean
  authorizationValid: boolean
  cameraCount: number
  activeCameraCount: number
  inferredCameraCount: number
  processed: number
  queued: number
  phase?: AiRuntimePhase | null
  snapshotAgeSeconds?: number | null
}

export interface AiIncidentLocation { function: string; file: string; line: number }

export interface AiServerStatus {
  agentId: string
  name: string
  health: 'online' | 'offline' | 'maintenance' | 'unknown'
  lastSeenAtUtc: string | null
  maintenanceUntilUtc: string | null
  runtimeHealth?: AiRuntimeHealth | null
  runtimeHealthAtUtc?: string | null
}

export interface AiServerIncident {
  id: string
  agentId: string
  agentName: string
  companyId?: string | null
  clientId?: string | null
  cameraId?: string | null
  cameraName?: string | null
  component: string
  operation: string
  code: string
  safeMessage: string
  severity: AiIncidentSeverity
  state: AiIncidentState
  occurrenceCount: number
  firstOccurredAtUtc: string
  lastOccurredAtUtc: string
  recoveredAtUtc?: string | null
  httpStatus?: number | null
}

export interface AiServerIncidentDetail extends AiServerIncident {
  incidentId: string
  revision: number
  location?: AiIncidentLocation | null
  exceptionType?: string | null
  frames: AiIncidentLocation[]
  runId?: string | null
  bootId?: string | null
  source: 'agent' | 'monitor' | 'history'
}

export interface AiServerIncidentsResponse {
  items: AiServerIncident[]
  total: number
  page: number
  pageSize: number
  summary: { activeCount: number; errorCount: number; recoveredCount: number }
  servers: AiServerStatus[]
  retentionDays: number
  maximumIncidents: number
}

export function getAiServerIncidents(query: URLSearchParams, signal: AbortSignal) {
  return api<AiServerIncidentsResponse>(`/platform/ai-server/incidents?${query}`, {
    signal,
    cache: 'no-store',
  })
}

export function getAiServerIncident(id: string, signal: AbortSignal) {
  return api<AiServerIncidentDetail>(`/platform/ai-server/incidents/${encodeURIComponent(id)}`, {
    signal,
    cache: 'no-store',
  })
}
